import React from 'react';

function BodyPaint({ fill = '#666' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill={fill}
        stroke={fill}
        strokeWidth="0.4"
        d="M11.794 18.3v-2.25H6.488v-.412h11.025v.413h-5.306v2.25h-.413zm-2.612-6.168a.45.45 0 00.334-.144.458.458 0 00.141-.329.44.44 0 00-.144-.324.457.457 0 00-.662.004.474.474 0 00-.131.328c0 .122.044.23.134.324.09.094.2.14.328.14zm5.644 0c.129 0 .24-.048.334-.144a.458.458 0 00.14-.329.44.44 0 00-.143-.324.457.457 0 00-.662.004.474.474 0 00-.132.328c0 .122.045.23.135.324.09.094.199.14.328.14zm-7.1-1.781l1.087-3.113a.329.329 0 01.143-.197.43.43 0 01.232-.065h5.625a.43.43 0 01.233.065c.07.044.117.11.142.197l1.088 3.113v4.2c0 .065-.02.12-.06.161a.206.206 0 01-.157.064h.02a.205.205 0 01-.156-.064.226.226 0 01-.06-.161v-1.313H8.138v1.313c0 .065-.02.12-.06.161a.206.206 0 01-.156.064h.02a.206.206 0 01-.156-.064.226.226 0 01-.06-.161v-4.2zm.506-.244h7.538l-.938-2.719H9.17l-.938 2.719zm-.094 2.719h7.725v-2.307H8.138v2.307z"
      ></path>
      <rect
        width="17.2"
        height="17.2"
        x="3.4"
        y="3.4"
        stroke={fill}
        strokeWidth="0.8"
        rx="1.1"
      ></rect>
    </svg>
  );
}

export default BodyPaint;
